import { render, staticRenderFns } from "./UsersDetail.container.vue?vue&type=template&id=32e0b077&scoped=true&"
import script from "./UsersDetail.container.vue?vue&type=script&lang=ts&"
export * from "./UsersDetail.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e0b077",
  null
  
)

export default component.exports